<div class="d-flex flex-wrap">
    <div *ngFor="let cl of items" class="card m-3" style="min-width: 200px">

        <div class="card-header">
            {{cl.name}}
        </div>
        <div class="card-body">
            <div>Price: {{cl.price}}</div>
            <div *ngIf="!cl.consumable">
                <h6>Equipment</h6>
                <app-attribute-store [attributes]="cl.effect_equip"></app-attribute-store>
            </div>
            <div *ngIf="cl.consumable">
                <h6>Consumable</h6>
                <span *ngIf="cl.effect_consumed?.exp">exp: {{cl.effect_consumed?.exp}}</span>
                <span *ngIf="cl.effect_consumed?.health">health: {{cl.effect_consumed?.health}}</span>
                <span *ngIf="cl.effect_consumed?.energy">energy: {{cl.effect_consumed?.energy}}</span>
                <app-attribute-store [attributes]="cl.effect_consumed"></app-attribute-store>
            </div>

        </div>
    </div>
</div>